/**
 * @see https://github.com/s-yadav/react-number-format
 */

import React from 'react';
import * as PropTypes from 'prop-types';
import NumberFormat from 'react-number-format';
import { get, omit } from 'lodash';
import Field from './index';

const parseValue = (obj) => get(obj, 'floatValue', null);

export const renderNumberInput = ({
  value,
  onChange,
  onFocus,
  onBlur,
  onKeyDown,
  onMouseUp,
  meta,
  ...props
}) => {
  const id = props.id || props.name || undefined;
  const isValid = !(meta.error || meta.warning);
  const validationMessage = meta.touched
    ? meta.error || meta.warning || props.validationMessage
    : props.validationMessage;

  const nextProps = {
    ...props,
    type: 'text',
    value,
    id,
    isValid,
    validationMessage,
    onChange,
    onBlur,
    onFocus,
    onKeyDown,
    onMouseUp,
  };

  return <Field {...nextProps} />;
};

export class NumberField extends React.Component {
  static propTypes = {
    allowNegative: PropTypes.bool,
    input: PropTypes.object.isRequired,
    meta: PropTypes.object.isRequired,
    numberFormat: PropTypes.any,
    numberMask: PropTypes.any,
    parseValue: PropTypes.func,
    thousandSeparator: PropTypes.string,
  };

  static defaultProps = {
    allowNegative: false,
    parseValue: parseValue,
    thousandSeparator: ' ',
  };

  handleValueChange = (valueObj) => {
    const {
      parseValue,
      input: { onChange },
    } = this.props;
    const value = parseValue(valueObj);
    onChange(value);
  };

  handleChange = (event) => {
    event.preventDefault();
  };

  handleFocus = (event) => {
    const {
      input: { value, onFocus },
    } = this.props;
    event.preventDefault();
    onFocus(value);
  };

  handleBlur = (event) => {
    const {
      input: { value, onBlur },
    } = this.props;
    event.preventDefault();
    onBlur(value);
  };

  render() {
    const {
      input,
      meta,
      input: { value, name },
      numberMask,
      numberFormat,
      ...props
    } = this.props;
    const passedProps = omit(props, ['parseValue', 'onDragStart', 'onDrop']);

    return (
      <NumberFormat
        customInput={renderNumberInput}
        {...passedProps}
        displayType={'input'}
        meta={meta}
        name={name}
        mask={numberMask}
        format={numberFormat}
        value={value}
        onBlur={this.handleBlur}
        onFocus={this.handleFocus}
        onChange={this.handleChange}
        onValueChange={this.handleValueChange}
      />
    );
  }
}

renderNumberInput.propTypes = {
  id: PropTypes.any,
  meta: PropTypes.any,
  name: PropTypes.string,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  onKeyDown: PropTypes.func,
  onMouseUp: PropTypes.func,
  validationMessage: PropTypes.any,
  value: PropTypes.any,
};
